import * as React from 'react'
import { useState } from 'react'
import TableRow from './TableRow'
import { DEFAULT_COLSPAN } from './TableDateGroupHeader'
import { TableJobCollapsedRowsButton } from './TableJobCollapsedRowsButton'

type TableJobRowsGroupProps = {
  jobId: string
  productionPlanningLines: any
  hideItems: boolean
  areas?: string[]
  filter: any
  showCompletedToday: boolean
  colorClass: string
}

export function TableJobRowsGroup(props: TableJobRowsGroupProps) {
  const { productionPlanningLines, hideItems, areas, showCompletedToday, jobId, colorClass, filter } = props
  const className = colorClass
  const defaultCollapseJobIds = filter?.collapse_job_ids || false

  const [hoveredJobId, setHoveredJobId] = useState(null)
  const [collapsed, setCollapsed] = useState(defaultCollapseJobIds)
  const toggleCollapse = () => {
    setCollapsed(!collapsed)
  }
  const collection = collapsed ? [productionPlanningLines[0]] : productionPlanningLines

  return (
    <>
      {collection.map(productionPlanningLine => {
        const key = `${productionPlanningLine.job_id}-${productionPlanningLine.solution_id}`
        return (
          <TableRow
            key={key}
            productionPlanningLine={productionPlanningLine}
            areas={areas}
            hideItems={hideItems}
            filter={filter}
            showCompletedToday={showCompletedToday}
            className={className}
            hoveredJobId={hoveredJobId}
            setHoveredJobId={setHoveredJobId}
            toggleCollapse={toggleCollapse}
          />
        )
      })}
      {collapsed && productionPlanningLines.length > 1 && (
        <tr>
          <td colSpan={DEFAULT_COLSPAN} className="text-left">
            <TableJobCollapsedRowsButton 
              hiddenLines={productionPlanningLines.slice(1)}
              toggleCollapse={toggleCollapse}
            />
          </td>
        </tr>
      )}
    </>
  )
}
